const config = {
	//"apiBase": '/'   //un comment for Server
    "apiBase": 'http://elan-api-dev.incedopay.com', //un comment for local 
    "base_url": `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
    "env": process.env.REACT_APP_ENV || 'develop'
    // "base_url": 'http://increwards-qa-admin-1666708928.us-east-2.elb.amazonaws.com',
    // "base_url": 'http://increwards-dev-admin-2024990315.us-east-2.elb.amazonaws.com',
    }

export default config